import { useDocuments } from '@/hooks/use-documents'
import { useMyJobMatches } from '@/hooks/use-external-jobs'
import { useSeveranceStatus } from '@/hooks/use-severance-status'

export function useNavVisibility() {
  const {
    data: documents,
    isPending: isDocumentsPending,
    isLoading: isDocumentsLoading,
    isError: isDocumentsError,
  } = useDocuments()
  const { data: jobMatches } = useMyJobMatches(0, 1)
  const { isSeveranceUser, severanceActive, severancePending } = useSeveranceStatus()

  const resumes = documents?.filter((d) => d.document_type === 'resume') || []
  const resumeCount = resumes.length
  const hasResume = resumes.some((d) => d.status === 'ready')
  const hasJobMatches = (jobMatches?.total ?? 0) > 0

  // Resume status is unresolved until the documents query settles. We must not
  // make routing decisions (e.g. hiding/locking the Opportunities route) while
  // it is still loading, otherwise a direct navigation/refresh races the fetch
  // and incorrectly redirects to /resume (PEL-433). On error we treat it as
  // resolved so the existing fallback (redirect to /resume) still applies.
  const isResumeStatusResolved = documents !== undefined || Boolean(isDocumentsError)

  return {
    hasResume,
    hasJobMatches,
    resumeCount,
    resumes,
    documents,
    isDocumentsPending,
    isDocumentsLoading,
    isResumeStatusResolved,
    isSeveranceUser,
    severanceActive,
    severancePending,
  }
}
